import { render, staticRenderFns } from "./empty-index.vue?vue&type=template&id=ee8c7b78&scoped=true"
import script from "./empty-index.vue?vue&type=script&lang=js"
export * from "./empty-index.vue?vue&type=script&lang=js"
import style0 from "./empty-index.vue?vue&type=style&index=0&id=ee8c7b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8c7b78",
  null
  
)

export default component.exports